import Layout from '@/layout/default-layout.vue';

const DASHBOARD = {
  path: '/dashboard',
  name: 'dashboard',
  component: Layout,
  children: [
    {
      path: 'monitor',
      name: 'Monitor',
      component: () => import('@/views/dashboard/monitor/index'),
      meta: { title: '实时监控' },
    },
  ],
};

export default DASHBOARD;
